// extracted by mini-css-extract-plugin
var _1 = "UserMultiValueContent-moduleUserMultiValue__sCajR";
var _2 = "UserMultiValueContent-moduleicon__KFtLV";
var _3 = "UserMultiValueContent-moduleicons__yBlLU";
export { _1 as "UserMultiValue", _2 as "icon", _3 as "icons" }
